<nav class="navbar navbar-expand-lg sticky-top top-bar navbar-dark bg-dark mt-3" *ngIf="userInfo">
  <div class="container-fluid">
    <a class="navbar-brand" [routerLink]="['/']">
      <img src="/assets/Logo_Horizontal_White.png" height="36" alt="ArkMed">
    </a>
    <div class="d-block">
      <span *ngIf="!production" class="badge bg-warning text-dark text-uppercase me-2 text-truncate"  style="max-width: 100px; ">{{ environmentName }}</span>
      <span *ngIf="versionInfo" class="badge bg-info text-dark text-uppercase text-truncate " style="max-width: 100px; font-size: 6px;">{{ versionInfo }}</span>
    </div>
    <button class="navbar-toggler text-bg-dark" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="pi pi-bars"></span>
    </button>

    <div class="offcanvas offcanvas-end  text-bg-dark" tabindex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
      <div class="offcanvas-header">
        <img *ngIf="this.userInfo?.ProfileImageURL" class="profileImage d-block" src="{{ this.getProfileImageURL }}" />
        <h5 class="offcanvas-title" id="offcanvasNavbarLabel">
          {{this.userInfo.FirstName  }} {{this.userInfo.LastName  }} <br /> {{this.userInfo.Email }}
        </h5>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close" id="offcanvasNavbarClose">
        </button>
      </div>
      <div class="offcanvas-body">
        <ul class="navbar-nav justify-content-end flex-grow-1 pe-3">
          @for (item of items; track item) {
          <li class="nav-item" *ngIf="!item.items">
            <a class="nav-link " [href]="itemLink(item)" (click)="clickItem(item)">
              <i [class]="item.icon"></i>
              {{item.label}}
            </a>
          </li>
          <li class="nav-item dropdown d-none d-lg-block" *ngIf="item.items">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              <i [class]="item.icon"></i>
              {{item.label}}
            </a>
            <ul class="dropdown-menu">
              <li class="dropdown-item" *ngFor="let subItem of item.items">
                <a [href]="itemLink(subItem)" (click)="clickItem(subItem)">
                  <i [class]="subItem.icon"></i>
                  {{subItem.label}}
                </a>
              </li>
            </ul>
          </li>
          <li class="nav-item d-block d-lg-none " *ngIf="item.items">
            <i [class]="item.icon"></i>
            {{item.label}}
          </li>
          <li class="nav-item  d-block d-lg-none " *ngFor="let subItem of item.items">
            <a class="nav-link ps-3" [href]="itemLink(subItem)" (click)="clickItem(subItem)">
              <i [class]="subItem.icon"></i>
              {{subItem.label}}
            </a>
          </li>
          }
        </ul>
      </div>
    </div>
    <div class="d-none d-lg-block text-bg-dark">
      <img *ngIf="this.userInfo?.ProfileImageURL" class="smallProfileImage d-block" src="{{ this.getProfileImageURL }} "  />
      <div *ngIf="!this.userInfo?.ProfileImageURL" class="smallProfileImage d-block bg-primary  text-center" style="height: 25px; width: 25px;">{{ this.profileInitials() }}</div>
    </div>
  </div>
</nav>
